import Image from 'next/image';

import ImageHeaderBG from './assets/header-bg.png';
import ImageHeaderSP from './assets/header-sp.png';
import ImageHeader from './assets/header.png';
import ImageSupported from './assets/supported.png';

export const Header = () => {
  return (
    <div className='relative flex w-full flex-col items-center justify-center py-[50px] lg:py-[73px]'>
      <div className='relative z-10 flex flex-col items-center justify-center gap-[30px] bg-white px-[90px] py-[42px]'>
        <Image
          className='hidden w-[685px] lg:block'
          src={ImageHeader}
          alt='INTILAQオンラインレポート'
        />
        <Image
          className='block w-[250px] lg:hidden'
          src={ImageHeaderSP}
          alt='INTILAQオンラインレポート'
        />
        <p className='text-title-strong-small__sp lg:text-title-strong-small'>
          東北社会起業家が生み出すインパクト
        </p>
        <Image className='w-[166px]' src={ImageSupported} alt='supported by ORBIS' />
      </div>
      <Image
        className='absolute left-0 top-0 z-0 h-full w-full object-cover'
        src={ImageHeaderBG}
        alt='INTILAQオンラインレポート'
      />
    </div>
  );
};
